export const ENV = import.meta.env.VITE_ENV
export const API_BASE_URL = (["prod", "staging", "dev"].includes(ENV) ? "https://" : "http://") + import.meta.env.VITE_API_BASE_URL
export const SOCKET_BASE_URL = (["prod", "staging", "dev"].includes(ENV) ? "wss://" : "ws://") + import.meta.env.VITE_API_BASE_URL
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID
export const GOOGLE_ANALYTICS_ID = import.meta.env.VITE_GOOGLE_ANALYTICS_ID
export const LUCKY_ORANGE_ID = import.meta.env.VITE_LUCKY_ORANGE_ID
export const FORECAST_BASE_URL = "https://forecastapp.com/1327211"
export const FLOAT_BASE_URL = "https://makers.float.com"
export const APP_NAME = import.meta.env.VITE_APP_NAME
export const SUPPORT_EMAIL = import.meta.env.VITE_SUPPORT_EMAIL
